var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumbHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "gray",
    strokeLinecap: "square",
    d: "M4.74066667,14.3333333 C3.63666667,14.3333333 2.74066667,13.4373333 2.74066667,12.3333333 L2.74066667,5.66666667 L2,5.66666667 L8.66666667,1 L15.3333333,5.66666667 L14.6193333,5.66666667 L14.62,12.3333333 C14.62,13.4373333 13.724,14.3333333 12.62,14.3333333 L10.6666667,14.3333333 L10.6666667,9 L6.66666667,9 L6.66666667,14.3333333 L4.74066667,14.3333333 Z",
    transform: "translate(-2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbHome);
export default __webpack_public_path__ + "static/media/breadcrumb-home.0eaa76dc1f0a6b5d2ebaa2425b99ba5f.svg";
export { ForwardRef as ReactComponent };